import { CustomFilter, DiffOperation } from '../../../services/env-sync/types';

export enum Environment {
  QA = 'qa',
  PROD = 'prod',
}

export type SchemaComparisonItem = {
  schemaName: string;
  records: RecordComparisonItem[];
  customFilters: CustomFilter[];
  isExpanded: boolean;
};

export type RecordComparisonItem = {
  key: string;
  label: string;
  qa?: EnvRecord;
  prod?: EnvRecord;
  diff: DiffOperation[];
  flags?: {
    notForProduction?: boolean;
  };
  isExpanded: boolean;
  isSelected: boolean;
};

export type EnvRecord = {
  id: string;
  data: any;
};

export enum RecordStatus {
  CHANGED = 'changed',
  NOT_FOR_PROD = 'not-for-prod',
  ONLY_IN_PROD = 'only-in-prod',
  ONLY_IN_QA = 'only-in-qa',
  UNCHANGED = 'unchanged',
}
